<template>
  <div class="page-content">
    <div class="page-body">
      <div class="invoice-content">
        <div class="invoice-margin mt-5" v-if="invoiceData">
          <div class="text-size-12 ml-4">
            <!-- logo -->
            <img class="logo-image" src="../assets/kulibri_logo_orange.png" id="web-logo" />
          </div>

          <!-- buisness addreess -->
          <div class="text-size-12 ml-4 mt-4">
            <span>{{ $t("invoiceDetails.businessName") }}</span><br>
            <span>{{ $t("invoiceDetails.businessAddress1") }}</span><br>
            <span>{{ $t("invoiceDetails.businessAddress2") }}</span><br>
            <span>{{ $t("invoiceDetails.businessAddress3") }}</span><br>
            <span>{{ $t("invoiceDetails.businessTaxCode") }}</span>
          </div>

          <!-- user addreess -->
          <div class="text-size-12 ml-4 mt-4">
            {{ user.email }}
          </div>

          <!-- invoice number -->
          <div class="text-size-12 ml-4 mt-4">
            {{  $t('invoiceDetails.invoiceNumber')  }}: {{ this.invoiceData.key}}
          </div>

          <!-- invoice table -->
          <div class="invoice-table mt-3" v-if="invoiceData">
            <div class="invoice-data">
              <table>
                <tr>
                  <th>
                    <p>
                      {{ $t('invoiceDetails.date') }}
                    </p>
                    <span>(DD.MM.YYYY)</span>
                  </th>
                  <th>
                    {{ $t('invoiceDetails.description') }}
                  </th>
                  <th>
                    {{ $t('invoiceDetails.period') }}
                  </th>
                  <th>
                    {{ $t("invoiceDetails.vatPercent") }}
                  </th>
                  <th>
                    <!-- VAT -->
                    {{ $t("invoiceDetails.vat") }}
                  </th>
                  <th>
                    {{ $t("invoiceDetails.subtotal") }}
                  </th>
                </tr>
                <tr class="main_data_row">
                  <td >
                    {{ convertToDateFormat(invoiceData.invoice_start_date) }}
                  </td>
                  <td>
                    <!-- supporter membership -->
                    {{ $t('package.premiumPackageName') }}
                    <!-- or -->
                    <!-- {{ invoiceData.subscription.description}} -->
                  </td>
                  <td>
                    {{  convertToDateFormat(invoiceData.invoice_start_date, false) }}
                    - {{ convertToDateFormat(invoiceData.invoice_end_date, false) }}
                  </td>
                  <td>
                    {{ getVatPersentage() + '%'}}
                  </td>
                  <td>
                  {{  parseFloat(invoiceData.subscription.membership.vat_amount).toFixed(2).replace('.',',')  }}
                    {{ $t('invoiceDetails.eur') }}
                  </td>
                  <td>
                    {{ parseFloat(invoiceData.subscription.membership.price).toFixed(2).replace('.',',') }} {{ $t('invoiceDetails.eur') }}
                  </td>
                </tr>
                <tr
                >
                  <!-- first invoice is generated on the payment date -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <th>
                    {{ $t("invoiceDetails.total") }}
                  </th>
                  <td>
                    {{ (parseFloat(invoiceData.subscription.membership.price) +  parseFloat(invoiceData.subscription.membership.vat_amount)).toFixed(2).replace('.',',')  }} {{ $t('invoiceDetails.eur') }}
                  </td>
                </tr>
              </table>
            </div>
            <p class="text-size-12 ml-4 mt-4">
              <strong>{{ $t("invoiceDetails.paymentMethod") }}</strong> </p>

            <p class="text-size-12 ml-4">{{ getPaymentMethod }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/shared/http';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'PrintInvoiceDetails',
  data() {
    console.log(this.$route.params.id);
    return {
      invoiceData: null,
    };
  },
  created() {
    const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
    const url = apiUrl + '/print-invoice-details/' + this.$route.params.id;
    HTTP.get(url)
      .then((response) => {
        this.invoiceData = response.data;
        // console.warn(this.invoiceData);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    ...mapState({
      user: (state) => state.Login.user,
    }),

    getPaymentMethod() {
      if (this.invoiceData && this.invoiceData.subscription.payment_method) {
        let method = this.invoiceData.subscription.payment_method;
        if(this.invoiceData.subscription.payment_method.toLowerCase() == "paypal") {
          method += "  " + '(' +this.user.email +')';
        }
        if(['mastercard', 'creditcard'].indexOf(this.invoiceData.subscription.payment_method.toLowerCase())) {
          method += "  " + '('+ this.invoiceData.subscription.details.cardNumber +')';
        }
        return method;
      }
      return this.$t('membership.notFound');
    },
  },
  methods: {
    convertToDateFormat(date, useDefault = true) {
      if (date) {
        if (useDefault == true) {
          return moment(String(date)).format('DD.MM.YYYY');
        } else {
          return moment(String(date)).format('DD.MM.YY');
        }
      }
    },

    getVatPersentage(){
      return Math.round((this.invoiceData.subscription.membership.vat_amount * 100)/ this.invoiceData.subscription.membership.price);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/style.scss';

.page-content {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-color: $very-light-grey;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.page-body {
  overflow: auto;
}

.invoice-content {
  display: flex;
  flex-direction: column;
}

.invoice-margin {
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-left: $mobile-margin-left;
  padding-right: $mobile-margin-left;
  color: $dark-grey;
}

/* .current-membership {
  max-width: 1050px;
  color: $mid-grey;
  background-color: $white;
  border-radius: 9px;
  padding: 10px;
} */
.main_data_row {
  height: 150px;
  vertical-align: baseline;
}
p {
  margin-bottom: 0px;
}

tr th,
tr td {
  padding: 10px 23px;
  text-align: center;
  font-size: $small;
  // border-bottom: solid 2px $mid-grey;
}

tr {
  border: 2px solid $mid-grey;
}
/* .current-membership-header {
  font-size: $standard;
  color: $dark-grey;
  font-weight: $medium-weight;
} */

@media screen and (min-width: 481px) {
  .invoice-margin {
    margin-left: $desktop-margin-left !important;
    padding: 0px;
  }
}
</style>
